import { Ref, TableConfig } from '@repo/sdk/models/components';

import { deduplicateSubscriptionIdentifiers } from '@/features/equipment-browser/equipment-details/state/identifiers.helpers';
import {
  mapReadingRefsToSubscriptionIdentifiers,
  mapSettingRefsToSubscriptionIdentifiers,
} from '@/features/equipment-browser/subscriptions/map-to-subscription-identifiers';
import { extractRefsFromConditionExpression } from '@/helpers/extract-refs';
import { SubscriptionIdentifier } from '@/hooks/query-hooks/gaia-api/use-subscription-base';

/**
 * Extracts refs from action-component condition expressions, then maps and
 * deduplicates them into subscription identifiers. The `isSettingRef` flag
 * controls whether setting or reading refs are extracted, and the corresponding
 * mapping function converts them into the right identifier type.
 */
const extractActionComponentIdentifiers = (
  config: TableConfig | undefined,
  isSettingRef: boolean,
  mapper: (refs: Ref[], source: string) => SubscriptionIdentifier[],
  source: string
): SubscriptionIdentifier[] => {
  if (!config) return [];

  const refs: Ref[] = [];

  for (const row of config.rows) {
    for (const ref of row.refs) {
      if (!ref.actionComponent?.states) continue;
      for (const state of ref.actionComponent.states) {
        refs.push(...extractRefsFromConditionExpression(state.conditionExpression, isSettingRef));
      }
    }
  }

  return deduplicateSubscriptionIdentifiers(mapper(refs, source));
};

export const extractBulkEditViewActionComponentSettingsIdentifiers = (
  config?: TableConfig
): SubscriptionIdentifier[] =>
  extractActionComponentIdentifiers(
    config,
    true,
    mapSettingRefsToSubscriptionIdentifiers,
    'bulk-edit-settings'
  );

export const extractBulkEditViewActionComponentReadingsIdentifiers = (
  config?: TableConfig
): SubscriptionIdentifier[] =>
  extractActionComponentIdentifiers(
    config,
    false,
    mapReadingRefsToSubscriptionIdentifiers,
    'bulk-edit-readings'
  );
